import { faCircleX } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack } from '@mui/material';
import { OutlinedButton } from '@pages/UploadPage/styles';
import { useInvalidateQueries } from '@partful/shared/lib/hooks/useInvalidateQueries';
import { WizardPageContent, WizardPageLayout } from '@partful/shared/ui/layouts/WizardPageLayout';
import { LoadingMessage } from '@partful/shared/ui/LoadingMessage/LoadingMessage';
import { useTranslation } from 'react-i18next';
import { useCancelPartsCategoriesJob } from '../lib/hooks/useCancelPartsCategoriesJob';
import { usePartsCategoriesForm } from '../lib/hooks/usePartsCategoriesForm';

interface PartsCategoriesProcessingProps {
  accountId: string;
  runID: string;
}

export function PartsCategoriesProcessing({ accountId, runID }: PartsCategoriesProcessingProps) {
  const { t } = useTranslation('manageProduct');
  const { cancelJob: cancelInProgressJob } = useCancelPartsCategoriesJob();
  const { resetForm } = usePartsCategoriesForm();
  const { invalidateContentProcessingJobsQueries } = useInvalidateQueries();

  const cancelJob = async () => {
    await cancelInProgressJob(accountId, runID!);
    resetForm();
    await invalidateContentProcessingJobsQueries();
  };

  return (
    <WizardPageLayout>
      <WizardPageContent>
        <Stack sx={{ alignItems: 'center' }}>
          <LoadingMessage
            title={t('partsCategories.processingPage.processing.title')}
            message={t('partsCategories.processingPage.processing.feelFreeToLeave')}
            actions={
              <OutlinedButton color="error" endIcon={<FontAwesomeIcon icon={faCircleX} />} onClick={() => cancelJob()}>
                {t('common:cancel')}
              </OutlinedButton>
            }
          />
        </Stack>
      </WizardPageContent>
    </WizardPageLayout>
  );
}
